// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react';
import './LicenseAgreements.scss';
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { signOut } from 'firebase/auth';

export default function LicenseAgreements({ firestore, auth, uid }) {
    const { i18n, t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const licenseAgreementDocId = location.state?.licenseAgreementDocId;

    const [licenseAgreementText, setLicenseAgreementText] = React.useState(null);

    React.useEffect(() => {
        async function loadLicenseAgreement() {
            const licenseAgreementRef = doc(firestore, "legal", "client_agreements", "license_agreements", licenseAgreementDocId);
            const licenseAgreementSnapshot = await getDoc(licenseAgreementRef);

            if (licenseAgreementSnapshot.exists()) {
                setLicenseAgreementText(licenseAgreementSnapshot.data()?.['text']);
            }
        }

        if (!licenseAgreementDocId) {
            return;
        }

        loadLicenseAgreement();
    }, []);

    async function writeLicenseAgreementDecision(accepted) {
        if (!uid) {
            return;
        }

        const userRef = doc(firestore, "users", uid);
        await setDoc(userRef, {
            legal: {
                license_agreement: {
                    [licenseAgreementDocId]: {
                        accepted: accepted,
                        timestamp: serverTimestamp(),
                    }
                }
            }
        }, { merge: true });
    }

    async function acceptLicenseAgreement() {
        await writeLicenseAgreementDecision(true);

        navigate("/");
        window.location.reload(false); 
    }

    async function declineLicenseAgreement() {
        writeLicenseAgreementDecision(false);

        signOut(auth);
        navigate("/login");
        window.location.reload(false);
    }

    return (
        <div className="license-agreement">
            <div className="license-agreement-form">
                <h1 className="license-agreement-title">{t("license_agreement_title")}</h1>
                <div className="license-agreement-text" dangerouslySetInnerHTML={{ __html: licenseAgreementText ?? "" }} />
                <div className="license-agreement-buttons">
                    <button onClick={declineLicenseAgreement}>{t("license_agreement_decline")}</button>
                    <button onClick={acceptLicenseAgreement}>{t("license_agreement_accept")}</button>
                </div>
            </div>
    </div>
    )
}